import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../utils/cn';

const Button = ({
      children,
      variant = 'primary',
      size = 'md',
      className,
      to,
      href,
      ...props
}) => {
      const baseStyles = "inline-flex items-center justify-center rounded-lg font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none";

      const variants = {
            primary: "bg-primary/80 backdrop-blur-md border border-white/20 text-white hover:bg-primary/90 shadow-lg hover:shadow-primary/20 dark:bg-white/90 dark:text-primary dark:hover:bg-white",
            secondary: "bg-white/10 backdrop-blur-md border border-white/20 text-gray-900 hover:bg-white/20 dark:text-white dark:border-white/10",
            outline: "bg-transparent backdrop-blur-sm border-2 border-primary/50 text-primary hover:bg-primary/10 dark:border-white/50 dark:text-white dark:hover:bg-white/10",
            ghost: "text-gray-700 hover:bg-gray-100/50 hover:backdrop-blur-sm dark:text-gray-300 dark:hover:bg-white/10",
            link: "text-primary underline-offset-4 hover:underline dark:text-blue-400",
      };

      const sizes = {
            sm: "h-9 px-3 text-xs",
            md: "h-10 px-4 py-2 text-sm",
            lg: "h-12 px-8 text-base",
            icon: "h-10 w-10",
      };

      const styles = cn(baseStyles, variants[variant], sizes[size], className);

      if (to) {
            return (
                  <Link to={to} className={styles} {...props}>
                        {children}
                  </Link>
            );
      }

      if (href) {
            return (
                  <a href={href} className={styles} {...props}>
                        {children}
                  </a>
            );
      }

      return (
            <button className={styles} {...props}>
                  {children}
            </button>
      );
};

export default Button;
